<page-data-manager>
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class="page-header">
        <h2>Propriedade</h2>
      </div>
    </div>

    <div class="col-xs-12">
      <div class="row">
        <div class="col-xs-12">
          <p><strong>Descrição:</strong> {{::cadastroPropriedade.propriedade.descricao}}</p>
          <p ng-if="cadastroPropriedade.propriedade.cidade"><strong>Cidade:</strong> {{::cadastroPropriedade.propriedade.cidade.nome}} - {{::cadastroPropriedade.propriedade.cidade.uf}}</p>
        </div>
      </div>
      <div class="row pull-right padding-top-10" ng-include="'views/cadastro_propriedades/_show_buttons.html'"></div>
    </div>
  </div>
</page-data-manager>
